import React from 'react'
import Bookmark from '../../../assets/img/bookmark.png'
import '../Bookmarks.css'
const PageInfo = () => {
  return (
    <div className="bookmarks">
      <h1>Bookmarked pages</h1>
      <p>
        This page displays all the pages you&apos;ve bookmarked on our website.
      </p>
      <p></p>
      <p>
        Bookmarking helps you quickly return to pages you visit often or want to
        read later. To bookmark a page, simply click the &apos;Bookmark to My
        account&apos; button&nbsp;
        <img
          src={Bookmark}
          alt="Bookmark to my account"
          className="bookmark-img"
        />
        &nbsp;located at the bottom of any page.
      </p>
      <p></p>
      <h2>Your bookmarked pages</h2>
      <p></p>
    </div>
  )
}

export default PageInfo
